/**
 * ChoiceView — multiple choice (существующий тип, default).
 *
 * Игрок выбирает вариант-кнопку → onAnswer({kind:'choice', option}); немедленная
 * оптимистичная блокировка. После reveal верный подсвечивается зелёным,
 * ошибочный выбор — красным. Spectate (ведущий): варианты только показываются +
 * живая статистика counts барами.
 */
import { useState } from 'react';
import { choiceOptions, type PlayerAnswer } from '../../protocol';
import { OptionsBoard } from './OptionsBoard';
import type { QuestionBodyProps } from './types';

export function ChoiceView({
  question,
  variant,
  myAnswer,
  reveal,
  counts,
  onAnswer,
}: QuestionBodyProps): JSX.Element {
  const options = choiceOptions(question);
  const initial = myAnswer?.kind === 'choice' ? myAnswer.option : null;
  const [selected, setSelected] = useState<number | null>(initial);

  const correctOption = reveal?.correctOption ?? null;
  const locked = variant === 'answer' && (selected !== null || reveal !== null);

  function handlePick(i: number): void {
    if (locked) return;
    setSelected(i);
    const answer: PlayerAnswer = { kind: 'choice', option: i };
    onAnswer(answer);
  }

  return (
    <OptionsBoard
      options={options}
      variant={variant}
      selected={selected}
      locked={locked}
      correctOption={correctOption}
      counts={counts}
      showCorrectMark
      onPick={handlePick}
    />
  );
}
